import { ApolloProvider } from "@apollo/client/react/context/ApolloProvider";
import { useMemo } from "react";

import { getApolloClient } from "~/utils/apolloClient";

interface GraphQLProviderProps {
  children: React.ReactNode;
  graphqlUrl?: string;
  accessToken?: string;
  creatorGraphqlUrl?: string;
}

export function GraphQLProvider({
  children,
  accessToken,
  graphqlUrl,
  creatorGraphqlUrl,
}: GraphQLProviderProps) {
  if (!graphqlUrl) {
    return <>{children}</>;
  }

  const apolloClient = useMemo(
    () => getApolloClient(graphqlUrl, creatorGraphqlUrl, accessToken),
    [graphqlUrl, creatorGraphqlUrl, accessToken],
  );

  if (!apolloClient) {
    return <>{children}</>;
  }

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}
